(function() {
    'use strict';

    angular
        .module('jotApp')
        .directive('hideColumnBy', hideColumnBy);

    function hideColumnBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^hideColumn',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            $(element[0].firstChild).on('click', function(event) {
                var $target = $( event.currentTarget );
                parentCtrl.checkCheckbox($target);
            });
            $(element).on('click', function(event){
                var $target = $( event.currentTarget ),
                    $inp = $target.find( 'input' );
                var storage = event.currentTarget.attributes[0].value.split('.')[0];
                parentCtrl.checkCheckbox($inp);
                parentCtrl.changeVisibility(storage, event.currentTarget.innerText);
                event.stopPropagation();
            });
        }
    }
})();
